<template>
  <emat-order-action
    name="order-action"
    :label="label"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import EmatOrderAction from 'Components/Layout/OrderAction';

export default {
  name: 'DeliveryTime',

  components: {
    EmatOrderAction,
  },

  computed: {
    ...mapGetters('build', [
      'deliveryDays',
    ]),

    label() {
      if (this.deliveryDays === 1) {
        return this.$t('DeliveryTime.delivered_tomorrow', { days: this.deliveryDays });
      } else {
        return this.$t('DeliveryTime.delivered_in_days', { days: this.deliveryDays });
      }
    },
  },
};
</script>
